module.exports = __webpack_public_path__ + "img/welcome-4-card.b35e0373.png";